import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const CTASection = () => {
  const { t } = useTranslation();
  return (
    <section id="cta" className="bg-background border-t border-border">
      <div className="container-x py-24 md:py-32">
        <div className="max-w-4xl">
          <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-6">
            {t("cta.eyebrow")}
          </p>
          <h2 className="font-display text-4xl md:text-6xl font-light tracking-tight text-foreground leading-[1.05]">
            {t("cta.title")}
          </h2>
          <p className="mt-8 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed">
            {t("cta.desc")}
          </p>

          <div className="mt-12 flex flex-wrap gap-4">
            <a
              href="https://wa.me/5565999560139"
              target="_blank"
              rel="noopener"
              onClick={() => {
                if (typeof window !== 'undefined' && (window as any).gtag) {
                  (window as any).gtag('event', 'conversion_event_contact', {});
                }
              }}
              className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors shadow-[0_10px_40px_-10px_hsla(212,100%,50%,0.5)]"
            >
              {t("cta.primary")} <span aria-hidden>→</span>
            </a>
            <a
              href="mailto:gabriel.souzagomes90@gmail.com"
              className="inline-flex items-center gap-2 glass-pill rounded-full px-6 py-3 text-sm font-medium text-foreground"
            >
              {t("cta.secondary")}
            </a>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 border-t border-border">
        <Link
          to="/contact"
          className="group relative bg-cream text-cream-foreground p-12 md:p-16 flex flex-col justify-between min-h-[280px] overflow-hidden"
        >
          <p className="text-[10px] uppercase tracking-[0.3em] text-cream-foreground/60">
            {t("cta.demoTag")}
          </p>
          <div>
            <h3 className="font-display text-3xl md:text-4xl font-light tracking-tight">
              {t("cta.demoTitle")}
            </h3>
            <p className="mt-3 text-sm text-cream-foreground/70 max-w-sm">
              {t("cta.demoDesc")}
            </p>
          </div>
          <span className="absolute bottom-12 right-12 text-2xl transition-transform group-hover:translate-x-2">
            →
          </span>
        </Link>
        <Link
          to="/platforms/aip"
          className="group relative bg-foreground text-background p-12 md:p-16 flex flex-col justify-between min-h-[280px] overflow-hidden"
        >
          <p className="text-[10px] uppercase tracking-[0.3em] text-background/60">
            {t("cta.buildTag")}
          </p>
          <div>
            <h3 className="font-display text-3xl md:text-4xl font-light tracking-tight">
              {t("cta.buildTitle")}
            </h3>
            <p className="mt-3 text-sm text-background/70 max-w-sm">
              {t("cta.buildDesc")}
            </p>
          </div>
          <span className="absolute bottom-12 right-12 text-2xl transition-transform group-hover:translate-x-2">
            →
          </span>
        </Link>
      </div>
    </section>
  );
};
